import { StaticImage } from "gatsby-plugin-image"

import { Heading } from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import ProductCards from "../../product-cards/product-cards"

const Products = () => (
  <>
    <div
      sx={{
        mb: 6,
        border: "1px",
        borderColor: ["brandNeutralsMediumGrey", "transparent"],
        borderRadius: "8px",
        overflow: "hidden",
        display: [null, "grid"],
        gridTemplateColumns: [null, "1fr 1fr"],
      }}
    >
      <StaticImage
        src="../../../../images/rebranded/rebranded-product-set.png"
        alt=""
        sx={{
          width: "100%",
        }}
      />
      <div sx={{ pt: 4, px: 4, pb: 5 }}>
        <Heading as="h3" size="xsm" mb={4} sx={{ lineHeight: "body" }}>
          <Trans i18nKey="ChoosePlan.Products.title" />
        </Heading>

        <ProductCards />
      </div>
    </div>
  </>
)

export default Products
